import { render, staticRenderFns } from "./diamondInvoice.vue?vue&type=template&id=d7f5c952&"
import script from "./diamondInvoice.vue?vue&type=script&lang=js&"
export * from "./diamondInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports